import { render, staticRenderFns } from "./CoursesAndProgrammes.vue?vue&type=template&id=7342f741&scoped=true"
import script from "./CoursesAndProgrammes.vue?vue&type=script&lang=js"
export * from "./CoursesAndProgrammes.vue?vue&type=script&lang=js"
import style0 from "./CoursesAndProgrammes.vue?vue&type=style&index=0&id=7342f741&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7342f741",
  null
  
)

export default component.exports